import React from 'react'
import HomeOwners from '../../../views/Insurance/HomeOwners/HomeOwners'

const HomeOwnersInsurance = () => {
  return (
    <HomeOwners/>
  )
}

export default HomeOwnersInsurance